module.exports = __webpack_public_path__ + "img/cutdownPriceBanner@2x.e404b7e2.png";